(() => { const init = () => {
(function(){
  'use strict';
  var viewport=document.getElementById('pfPhotoViewport');
  var track=document.getElementById('pfPhotoTrack');
  if(!viewport||!track||viewport.dataset.ready)return;viewport.dataset.ready='1';
  var groups=track.querySelectorAll('.pf-photo-group');
  if(groups.length!==3)return;
  var reduce=window.matchMedia&&window.matchMedia('(prefers-reduced-motion: reduce)');
  var groupWidth=0,offset=0,last=0,down=false,lastX=0,holdUntil=0,hover=false,focus=false;
  var speed=.13; // px/ms, desplazamiento continuo de 130 px por segundo.
  function wrap(x){return groupWidth?((x%groupWidth)+groupWidth)%groupWidth:0}
  function render(){
    if(!groupWidth)return;
    track.style.transform='translate3d('+(-groupWidth-offset)+'px,0,0)';
  }
  function measure(){
    var nextWidth=groups[1].getBoundingClientRect().width;
    if(!nextWidth)return;
    if(groupWidth)offset=offset*nextWidth/groupWidth;
    groupWidth=nextWidth;
    offset=wrap(offset);
    render();
  }
  function frame(t){
    if(!last)last=t;
    var delta=Math.min(Math.max(t-last,0),80);last=t;
    if(groupWidth&&!down&&!hover&&!focus&&t>holdUntil&&!document.hidden&&!(reduce&&reduce.matches)){
      offset=wrap(offset+delta*speed);
      render();
    }
    if(track.isConnected)window.requestAnimationFrame(frame);
  }
  viewport.addEventListener('pointerdown',function(e){
    if(e.button!==undefined&&e.button!==0)return;
    down=true;lastX=e.clientX;
    if(viewport.setPointerCapture)try{viewport.setPointerCapture(e.pointerId)}catch(_e){}
  });
  viewport.addEventListener('pointermove',function(e){
    if(!down||!groupWidth)return;
    var dx=e.clientX-lastX;lastX=e.clientX;
    offset=wrap(offset-dx);render();
  });
  function end(){down=false;holdUntil=performance.now()+1600}
  viewport.addEventListener('pointerup',end);
  viewport.addEventListener('pointercancel',end);
  viewport.addEventListener('lostpointercapture',end);
  viewport.addEventListener('mouseenter',function(){hover=true});
  viewport.addEventListener('mouseleave',function(){hover=false});
  viewport.addEventListener('focusin',function(){focus=true});
  viewport.addEventListener('focusout',function(){focus=false});
  window.addEventListener('resize',measure,{passive:true});
  // Start immediately; never require a click or a scroll to turn on autoplay.
  measure();
  if(track.isConnected)window.requestAnimationFrame(frame);
})();



(function(){
  'use strict';
  var root=document.getElementById('pfEjemploPedido');
  if(!root||root.dataset.ready)return;root.dataset.ready='1';
  var names=root.dataset.names.split('|');
  var cities=root.dataset.cities.split('|');
  var bundles=[{qty:1,price:'$89.900',image:root.querySelector('img').src},{qty:2,price:'$139.900',image:root.dataset.imageTwo},{qty:3,price:'$179.900',image:root.dataset.imageThree}];
  var n=root.querySelector('#pfPopName'), c=root.querySelector('#pfPopCity'), p=root.querySelector('#pfPopPackage'), picture=root.querySelector('#pfPopImage');
  var close=root.querySelector('#pfPopClose');
  var showTimer=null,hideTimer=null,cycleTimer=null,stopped=false,idx=-1;
  function show(){
    if(stopped || document.hidden || !root.isConnected)return;
    idx=(idx+1)%names.length;
    n.textContent=names[idx]; c.textContent=cities[idx];
    var b=bundles[idx%bundles.length];
    p.textContent=b.qty+' '+(b.qty===1?'unidad':'unidades')+' · '+b.price;
    picture.src=b.image;
    picture.alt='ProtafloX: '+b.qty+' '+(b.qty===1?'frasco':'frascos')+' ('+(b.qty*60)+' cápsulas)';
    root.classList.add('pf-pop-visible');
    window.clearTimeout(hideTimer);
    hideTimer=window.setTimeout(function(){root.classList.remove('pf-pop-visible')},5000);
  }
  function stop(){
    stopped=true;root.classList.remove('pf-pop-visible');
    window.clearTimeout(showTimer);window.clearTimeout(hideTimer);window.clearInterval(cycleTimer);
  }
  close.addEventListener('click',stop);
  document.addEventListener('visibilitychange',function(){
    if(document.hidden){root.classList.remove('pf-pop-visible');window.clearTimeout(hideTimer)}
  });
  // Atraso inicial: no tapa el contenido apenas se abre la página.
  showTimer=window.setTimeout(function(){
    show();cycleTimer=window.setInterval(show,16000);
  },7000);
})();


(function(){
  'use strict';
  var bar = document.getElementById('pfxTopCounter');
  if(!bar||bar.dataset.ready)return;bar.dataset.ready='1';
  var minutes = bar.querySelector('[data-pfx-minutes]');
  var seconds = bar.querySelector('[data-pfx-seconds]');
  var heading = bar.querySelector('[data-pfx-heading]');
  var configured = bar.getAttribute('data-deadline') || '';
  var parsed = configured ? Date.parse(configured) : NaN;
  var hasRealOfferDeadline = Number.isFinite(parsed);
  var deadline;

  if(hasRealOfferDeadline){
    // Solo al configurar una fecha real se anuncia el vencimiento de la oferta.
    deadline = parsed;
    heading.textContent = 'Oferta termina en';
  } else {
    // Temporizador de visita de doce minutos, sin vincularlo a un descuento.
    heading.textContent = 'Tu temporizador';
    var duration = Math.max(1, Number(bar.getAttribute('data-session-minutes')) || 12) * 60000;
    var storageKey = 'protaflox_session_timer_start_v1';
    var now = Date.now();
    var startedAt = now;
    try {
      var saved = Number(window.sessionStorage.getItem(storageKey));
      if(Number.isFinite(saved) && saved > 0 && saved <= now && (now - saved) < 24*60*60*1000){
        startedAt = saved;
      } else {
        window.sessionStorage.setItem(storageKey, String(startedAt));
      }
    } catch(error) {
      // Previsualizaciones locales pueden restringir sessionStorage.
    }
    deadline = startedAt + duration;
  }

  var intervalId = null;
  function tick(){
    var remaining = Math.max(0, Math.ceil((deadline - Date.now()) / 1000));
    minutes.textContent = String(Math.floor(remaining / 60)).padStart(2, '0');
    seconds.textContent = String(remaining % 60).padStart(2, '0');
    if(remaining === 0){
      heading.textContent = hasRealOfferDeadline ? 'Promoción finalizada' : 'Tiempo completado';
      if(intervalId !== null) window.clearInterval(intervalId);
    }
  }
  tick();
  if(deadline > Date.now()) intervalId = window.setInterval(tick, 1000);
})();

(function(){
  'use strict';
  const reduceMotion=window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if(reduceMotion || !('IntersectionObserver' in window))return;
  const elements=[...document.querySelectorAll('.pfx-reveal')];
  if(!elements.length)return;
  const visible=window.innerHeight || document.documentElement.clientHeight;
  elements.forEach(el=>{if(el.getBoundingClientRect().top<visible*.94)el.classList.add('pfx-in-view')});
  document.documentElement.classList.add('pfx-motion-enabled');
  const observer=new IntersectionObserver((entries)=>{
    entries.forEach(entry=>{
      if(entry.isIntersecting){entry.target.classList.add('pfx-in-view');observer.unobserve(entry.target)}
    });
  },{rootMargin:'0px 0px -32px 0px',threshold:.06});
  elements.forEach(el=>{if(!el.classList.contains('pfx-in-view'))observer.observe(el)});
})();
};document.readyState==='loading'?document.addEventListener('DOMContentLoaded',init):init();document.addEventListener('shopify:section:load',init);})();